export default "__VITE_ASSET__Cn_x$Jur__"